import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BranchofficeService } from 'src/app/api/admin/branchoffice.service';
import { ConfigService } from 'src/app/api/core/config.service';
import { GlobalService } from 'src/app/api/global.service';
import { MainSysComponent } from 'src/app/main-sys/main-sys.component';
import * as _ from 'underscore';

@Component({
  selector: 'app-branchoffice-list',
  templateUrl: './branchoffice-list.component.html',
  styleUrls: ['./branchoffice-list.component.css']
})
export class BranchofficeListComponent implements OnInit {
  branchoffices: any;
  company:any = null;
  activation:any = null;

  constructor(
    private configService: ConfigService,
    private globalService: GlobalService,
    private branchOfficeService: BranchofficeService,
    public router: Router
  ) {
    // console.log("entrando aca");
  }

  ngOnInit(): void {
    this.listBranchoffice();
    this.getModules();
  }

  listBranchoffice() {
    this.branchOfficeService.list().subscribe({
      next: (data: any) => {
        this.branchoffices = data.results;
        this.company = data.company;
        this.activation = data.activation;

        // guardar dato companía en cache
        localStorage.setItem('company', JSON.stringify(this.company));

        if(this.company.free_control){
          this.globalService.setPassActivation("activate");
        }else{
          if(this.activation != null){
            if(this.activation.days_available < 0){
              this.globalService.setPassActivation("not_activate");
            }else{
              this.globalService.setPassActivation("activate");
            }
          }else{
            this.globalService.setPassActivation("not_activate");
          }
        }
      }
    });
  }

  getModules(){
    this.configService.modulesSystem().subscribe({
      next: (data: any) => {
        localStorage.setItem('modulesSystem', JSON.stringify(data.modules));
      }
    });
  }

  setBranchOffice(slug: string) {
    this.globalService.setSlugBranchoffice(slug);
    let routeslist = this.router.config;
    routeslist.forEach((route) => {
      if(!_.isUndefined(route.data)){
        if(route.data["root_sys"] == "root_sys"){
          route.path = slug;
        }
      }
    });
    // console.log(routeslist);
    this.router.resetConfig(routeslist);
    // this.router.navigateByUrl(slug+'/dashboard');
    const targetUrl = slug + '/dashboard';
    this.router.navigateByUrl(targetUrl).then(() => {
      window.location.reload();
    });
  }
}